<p-dialog
  [header]="'PAGE.IMPORT_DIALOG_TITLE' | translate"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  [closable]="true"
>
  <form [formGroup]="form" class="flex flex-column gap-3 pt-2">

    <!-- Nombre del template -->
    <div class="flex flex-column gap-1">
      <label for="templateName" class="font-medium text-sm">
        {{ 'PAGE.IMPORT_NAME_LABEL' | translate }}
        <span class="text-red-500 ml-1">*</span>
      </label>
      <input
        id="templateName"
        type="text"
        pInputText
        formControlName="name"
        [placeholder]="'PAGE.IMPORT_NAME_LABEL' | translate"
        class="w-full"
        [ngClass]="{ 'ng-invalid ng-dirty': nameControl.invalid && nameControl.touched }"
      />
      <small
        *ngIf="nameControl.invalid && nameControl.touched"
        class="text-red-500"
      >
        {{ 'FORM.REQUIRED' | translate }}
      </small>
    </div>

    <!-- Selector de archivo JSON -->
    <div class="flex flex-column gap-1">
      <label class="font-medium text-sm">
        {{ 'PAGE.IMPORT_FILE_LABEL' | translate }}
        <span class="text-red-500 ml-1">*</span>
      </label>
      <div class="flex align-items-center gap-2">
        <label
          for="jsonFileInput"
          class="p-button p-button-outlined p-button-secondary cursor-pointer"
          style="display: inline-flex; align-items: center;"
        >
          <i class="pi pi-upload mr-2"></i>
          {{ 'PAGE.IMPORT_FILE_LABEL' | translate }}
        </label>
        <input
          id="jsonFileInput"
          type="file"
          accept=".json"
          class="hidden"
          (change)="onFileSelected($event)"
        />
        <span *ngIf="fileName" class="text-sm text-color-secondary overflow-hidden text-overflow-ellipsis">
          {{ fileName }}
        </span>
        <span *ngIf="!fileName" class="text-sm text-color-secondary">
          {{ 'PAGE.IMPORT_NO_FILE' | translate }}
        </span>
      </div>
    </div>

  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        type="button"
        [label]="'CANCEL' | translate"
        class="p-button-outlined p-button-secondary"
        icon="pi pi-times"
        (click)="cancel()"
        [disabled]="loading"
      ></button>
      <button
        pButton
        type="button"
        [label]="'PAGE.IMPORT_BTN' | translate"
        icon="pi pi-check"
        (click)="importTemplate()"
        [disabled]="form.invalid || !templateData || loading"
        [loading]="loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
